import { render, staticRenderFns } from "./MirrorsConfigsTab.vue?vue&type=template&id=128f0182&scoped=true&"
import script from "./MirrorsConfigsTab.vue?vue&type=script&lang=js&"
export * from "./MirrorsConfigsTab.vue?vue&type=script&lang=js&"
import style0 from "./MirrorsConfigsTab.vue?vue&type=style&index=0&id=128f0182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f0182",
  null
  
)

export default component.exports